import { getUserId } from 'lib/utils/authentication';
import RelayEnvironment from 'lib/utils/relay';
import { loadQuery } from 'react-relay';
import { userProfileQuery } from 'services/user/__generated__/userProfileQuery.graphql';
import { USER_PROFILE_QUERY } from 'services/user/user.relay.services';
import { countryCountriesQuery } from 'services/country/__generated__/countryCountriesQuery.graphql';
import { COUNTRIES_QUERY } from 'services/country/country.relay.services';
import { GET_PROFILE_QUESTIONS_QUERY, GET_SPECIALITIES_QUERY } from 'services/profile/profile.relay.services';
import { profileSpecialitiesQuery } from 'services/profile/__generated__/profileSpecialitiesQuery.graphql';
import { profileProfileQuestionsQuery } from 'services/profile/__generated__/profileProfileQuestionsQuery.graphql';

export const SettingsProfilePreloadData = Props => {
  const userId = getUserId();

  return {
    userProfileRef: loadQuery<userProfileQuery>(RelayEnvironment, USER_PROFILE_QUERY, {
      id: userId,
      skip: userId === '',
    }),
    countriesQueryRef: loadQuery<countryCountriesQuery>(RelayEnvironment, COUNTRIES_QUERY, { first: 1000 }),
    specialitiesQueryRef: loadQuery<profileSpecialitiesQuery>(RelayEnvironment, GET_SPECIALITIES_QUERY, {
      first: 1000,
      ordering: [{ sort: 'NAME', direction: 'ASC' }],
    }),
    profileQuestionsQueryRef: loadQuery<profileProfileQuestionsQuery>(
      RelayEnvironment,
      GET_PROFILE_QUESTIONS_QUERY,
      {},
    ),
  };
};

export type SettingsProfilePreloadDataType = ReturnType<typeof SettingsProfilePreloadData>;
